<template>
  <div class="flex flex-col user-select-none">
    <!--
    <p class="text-white text-lg">Duration {{timeline.duration}} / {{partutil.gamedata.gamedata.game.timelimit}}</p>
    -->
    <editor-player ref='player'
                   :transforms-and-source='transformsAndSource'
                   :gamedata='transformsAndSource.gamedata.gamedata' 
                   :enable-toolbar='false'
                   :block-pan='true'
                   class="flex flex-grow overflow-hidden relative"
                   :style='editorStyle'
                   @tick='onPlayerTick'
                   @edit='$emit("back")'
                   >
      <portal-target name="component-details"
                     class="absolute bottom-0 left-0 right-0 overflow-x-hidden drop-shadow"
                     />
    </editor-player>

    <div v-if='showTimeline' :style='timelineStyle' class="overflow-hidden">
      <timeline v-if='showTimeline'
                ref='timeline'
                class="w-full"
                :style='timelineStyle'
                :timeline='timeline'
                :current-time='timeSinceStart'
                :initial-selected-transform-tid='transform.id'
                :window-duration='windowDuration'
                @set-timelimit='onSetTimelimit'
                @select-transform-id='onSelectTransformTid'
                @updated-entry='onUpdateTimelineEntry'
                @add-timeline-event='onAddTimelineEvent'
                @remove-timeline-event='onRemoveComponent'
                >
        <template #tid='{id,cid,tid,select,color,selected,i}'>
          <portal v-if='i === 0' to="selections">
            <button class='relative timeline-transform-button w-12 h-14 pbc-z-level-2'
                    :class='selected ? "rselected" : "notrselected"'
                    :style='{"background-color":color}'
                    @click="select(tid)">
                <inline-render :transform='transformByTid[tid]'
                              :from='transformsAndSource.from'
                              :gamedata='transformsAndSource.gamedata'
                              :source='transformsAndSource.source'
                              class='h-12 w-full'
                              :background-color='backgroundColor' />
                  <div class="h-2">
                  </div>
            </button>
          </portal>
        </template>

        <template #aftertimeline='{tid,color,selected,selectedEntry}'>

          <div v-if='selected' class="w-full flex-none overflow-x-hidden overflow-y-hidden" >
            <portal to='component-details'>
              <pbc-button v-if='selectedEntry.__type === "animation"' @click='onRemoveComponent(selectedEntry.cid)'>
                <minus-circle :size='24' />
              </pbc-button>
              <pbc-button class="pbc-primary-color" @click='onAddTimelineEvent({event:selectedEntry})'>
                <plus-circle :size='24' />
              </pbc-button>

              <div v-if='selectedEntry.__type === "enter" || selectedEntry.__type === "exit" '>
              </div>
              <quick-change v-else :cid='selectedEntry.cid'
                            :component='componentsByCid[selectedEntry.cid]'
                            class="overflow-x-auto"
                            @change-type='onChangeType(selectedEntry, $event)' 
                            @change='onChangeComponentType'
                            @remove='onRemoveComponent' />

            <quick-component :gamedata='partutil.gamedata'
                             class="overflow-x-auto"
                             :partutil='partutil'
                             :component='componentsByCid[selectedEntry.cid]'
                             :transforms-and-source='transformsAndSource'
                             :transform='transformByTid[tid]' 
                             :enable-edit-button='false'
                             @change-component='onChangeTween(selectedEntry, $event)'
                             :key='selectedEntry.cid'
                             @change='onChangeComponent'
                            />
            </portal>
          </div>
        </template>
      </timeline>

      <portal-target name="selections" multiple />
    </div>

    <div class="flex-none w-full flex justify-end inline-flex flex-row h-16">
      <pbc-button @click="$emit('back')" class="bottom-action-button">
        <chevron-left />
        <span class="ml-1 mr-1">Place</span>
      </pbc-button>
      <button @click='showTimeline = !showTimeline' :class='animationClasses'>
        <timeline-clock-outline :size='32' />
        <p>Animate</p>
      </button>
      <button @click='onUndo' class='transparent-button mx-1 ml-2' :disabled='!undoStack.length'>
        <undo :size='32' />
        <p>Undo</p>
      </button>
      <button @click='onRedo' class='transparent-button mx-1' :disabled='!redoStack.length'>
        <redo :size='32' />
        <p>Redo</p>
      </button>
      <p class="grow" />
      <p v-if='false' class="grow text-gray-400 text-sm font-thin self-center text-center">Animate your meme by dragging timelines around and changing effects.</p>
      <!--
      <pbc-button @click="$emit('back')" class="pbc-minimal-button">
        <close class="mx-2"/>
      </pbc-button>
      -->
      <pbc-button @click="$emit('post')" class="bottom-action-button">
        <span class="ml-1 mr-1">Post</span>
        <chevron-right />
      </pbc-button>
    </div>

  </div>
</template>
<script>
import Undo from '@icons/Undo.vue';
import Redo from '@icons/Redo.vue';
import PlusCircle from '@icons/PlusCircle.vue';
import MinusCircle from '@icons/MinusCircle.vue';
import TimelineClockOutline from '@icons/TimelineClockOutline.vue';
import InlineRender from '@edit/atoms/InlineRender.vue';
//import Check from '@icons/Check.vue';
//import Close from '@icons/Close.vue';
import ChevronRight from '@icons/ChevronRight.vue';
import ChevronLeft from '@icons/ChevronLeft.vue';

import Treeutil from '@edit/tree/treeutil.js';
import QuickTransformEditComponents from '@edit/organisms/QuickTransformEditComponents.vue';
import { cloneDeep, debounce } from 'lodash';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import EditorPlayer from '@edit/organisms/EditorPlayer.vue';
import QuickComponent from '@ui/organisms/QuickComponent.vue';
import QuickChange from '@ui/molecules/QuickChange.vue';
import Timeline from '@ui/organisms/Timeline.vue';
import Animator from '@edit/tree/animator.js';

export default {
  props: {
    transformsAndSource: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    selectionsData: {
      type: Array,
      required: true
    }
  },
  data() {
    const component = this.partutil.findComponentForTransform(this.transform);
    const treeutil = new Treeutil(this.partutil.from);

    const gamedata = this.partutil.gamedata.gamedata;
    const backgroundColor = gamedata.game.bgcolor;
    const animator = new Animator(this.partutil.gamedata, this.partutil, gamedata.game.timelimit || 3, 15);
    const timeline = animator.getAllTimelines();
    const {componentsByCid,transformByTid} = this.getComponentsAndTransformCache(timeline);

    const height = window.innerHeight - 400;
    const editorStyle = {
      height:'200px'
    }

    const timelineStyle = {
    }

    let showTimeline = false;
    if (this.transform.id) {
      showTimeline = true;
    }

    return {
      treeutil,
      component,
      timeSinceStart: 0,
      timeline,
      animator,
      transformByTid,
      componentsByCid,
      backgroundColor,
      editorStyle,
      timelineStyle,
      showTimeline,
      undoStack:[],
      redoStack:[]
    }
  },
  mounted() {
    const gamedata = this.partutil.gamedata.gamedata;
    if (typeof(gamedata.timelimit) === 'undefined') {
      this.$set(gamedata.game, 'timelimit', this.timeline.duration);
    }
    this.restartGame = debounce(this._restartGame, 100);
    this.updateTimeline = debounce(this._updateTimeline, 100);

    //if (gamedata.game.timelimit === -1) {
      //this.$emit("post");
    //}

  },
  methods: {
    onUndo() {
      const data = this.undoStack.pop();

      const {type, undo} = data;
      console.log('UNDO', type);
      if (type === 'timeline') {

        const redo = this.animator.undoUpdate(this.timeline, undo);
        this.addToRedo('timeline', redo);
        this._updateTimeline();

      } else if (type === 'component') {

        const {nv,ov} = undo;
        this.addToRedo('component', {nv,ov:cloneDeep(nv)});

        Object.assign(nv, ov);

        this._updateTimeline();

      } else if (type === 'add-entry') {

        const {addedLinks, addedComponents, transform, event} = undo;
        const {removedComponents, removedLinks} = this.treeutil.removeComponentsAndLinks(addedComponents, addedLinks);
        this.addToRedo('add-entry', {removedComponents, removedLinks, transform, event});

        const {componentsByCid, transformByTid} = this.getComponentsAndTransformCache(this.timeline);
        this.componentsByCid = componentsByCid;
        this.transformByTid = transformByTid;

        this.timeline = this.animator.getAllTimelines();
        this._updateTimeline();
        this.restartGame();

      } else if (type === 'remove-component') {
        const {removedLinks, removedComponents} = undo;
        const {addedComponents, addedLinks} = this.treeutil.addComponentsAndLinks(removedComponents, removedLinks);
        this.addToRedo('remove-component', {addedComponents, addedLinks});

        this.timeline = this.animator.getAllTimelines();
        this._updateTimeline();
        this.restartGame();
      }
    },
    onRedo() {
      const data = this.redoStack.pop();

      const {type,redo} = data;
      console.log('REDO', type);
      if (type === 'timeline') {
        //console.log('before undo timeline', JSON.stringify(this.timeline, 0, 2));
        const undo = this.animator.redoUpdate(this.timeline, redo);
        this.addToUndo('timeline', undo, false);
        this._updateTimeline();
        //console.log('after redo timeline', JSON.stringify(this.timeline, 0, 2));
      } else if (type === 'component' ){
        const {nv,ov} = redo;
        this.addToUndo('component', {nv,ov:cloneDeep(nv)}, false);
        Object.assign(nv, ov);
      } else if (type === 'add-entry') {
        const {removedLinks, removedComponents, transform, event} = redo;

        const {addedLinks,addedComponents} = this.animator.addTimelineEntryForTransform(transform, event);

        this.timeline = this.animator.getAllTimelines();

        const {componentsByCid, transformByTid} = this.getComponentsAndTransformCache(this.timeline);
        this.componentsByCid = componentsByCid;
        this.transformByTid = transformByTid;

        this._updateTimeline();
        this.restartGame();

        this.addToUndo('add-entry', {addedComponents, addedLinks, transform, event}, false);

        this.timeline = this.animator.getAllTimelines();
        this._updateTimeline();
        this.restartGame();
/*

        const {addedComponents, addedLinks} = this.treeutil.addComponentsAndLinks(removedComponents, removedLinks);
        this.addToUndo('add-entry', {addedComponents, addedLinks});

        const {componentsByCid, transformByTid} = this.getComponentsAndTransformCache(this.timeline);
        this.componentsByCid = componentsByCid;
        this.transformByTid = transformByTid;

        this.timeline = this.animator.getAllTimelines();
        this._updateTimeline();
        this.restartGame();
        */
      } else if (type === 'remove-component') {
        const {addedLinks, addedComponents} = redo;
        const {removedComponents, removedLinks} = this.treeutil.removeComponentsAndLinks(addedComponents, addedLinks);
        this.addToRedo('remove-component', {addedComponents, addedLinks}, false);

        this.timeline = this.animator.getAllTimelines();
        this._updateTimeline();
        this.restartGame();
      }
    },
    getComponentsAndTransformCache(timeline) {
      const componentsByCid = {};
      const transformByTid = {};
      timeline.timeline.forEach( ({cid,tid}) => {
        transformByTid[tid] = this.partutil.gamedata.getTransformById(tid);
        componentsByCid[cid] = this.partutil.getComponentById(cid);
      });
      return {componentsByCid,transformByTid};
    },
    onAddTimelineEvent({event}) {
      //console.log('add entry for', event);
      const transform = this.transformByTid[event.tid];
      const {addedLinks,addedComponents} = this.animator.addTimelineEntryForTransform(transform, event);
      const addedComponent = addedComponents[0];
      console.log('added component', addedComponent);

      this.addToUndo('add-entry', {addedLinks, addedComponents, transform, event});

      this.timeline = this.animator.getAllTimelines();

      const {componentsByCid, transformByTid} = this.getComponentsAndTransformCache(this.timeline);
      this.componentsByCid = componentsByCid;
      this.transformByTid = transformByTid;

      this.restartGame();

      const newEvent = this.timeline.timeline.filter( ({cid}) => {
        return cid === addedComponent.id;
      })[0];
      this.$refs.timeline.onSelectEntry(newEvent, true);
    },
    onRemoveComponent(cid) {
      const component = this.partutil.getComponentById(cid);
      const {removedComponents,removedLinks} = this.treeutil.removeComponent(component);
      this.addToUndo('remove-component', {removedComponents, removedLinks});
      this.timeline = this.animator.getAllTimelines();
      this.restartGame();
    },
    onUpdateTimelineEntry({event}) {
      const undo = this.animator.updateTimelineEntry(this.timeline, event);
      this._updateTimeline();
      this.addToUndo('timeline', undo);
    },
    onSelectTransformTid(id, color) {
      //console.log('id,color', id, color);
      this.$refs.player.highlightTransform(id, color);
      //this.restartGame();
    },
    onSetTimelimit({seconds}) {
      const gamedata = this.partutil.gamedata.gamedata;
      this.$set(gamedata.game, 'timelimit', seconds);

      const {undo} = this.animator.extendDuration(this.timeline, seconds);
      this.addToUndo('timeline', undo);

      this.$set(this.timeline, 'duration', seconds);
      this.restartGame();
    },
    onPlayerTick({dt,timeSinceStart}) {
      this.timeSinceStart = (timeSinceStart/1000);
    },
    onChangeTween(selectedEntry, component) {
      if (selectedEntry.__type !== 'animation') {
        //console.log('change tween', component);
        if (component.tweens && component.tweens.length >0) {
          selectedEntry.label = component.tweens.map( (t) => {
            return t.name;
          }).join("\n");
        } else {
          selectedEntry.label = "None";
        }
      }
      const undo = this.animator.updateTimelineEntry(this.timeline, selectedEntry);
      this.restartGame();
    },
    onChangeType(selectedEntry, name) {
      selectedEntry.label = name;
      //const undo = this.animator.updateTimelineEntry(this.timeline, selectedEntry);
      //this.addToUndo('timeline', undo);
      this.restartGame();
    },
    addToUndo(type, undo, clearRedo=true) {
      console.trace('add to undo', type);
      this.undoStack.push({
        type, undo
      });
      if (clearRedo) {
        this.redoStack.splice(0, this.redoStack.length);
      }

    },
    addToRedo(type, redo) {
      this.redoStack.push({
        type, redo
      });
    },
    _restartGame() {
      this.$refs.player.restartGame();
    },
    _updateTimeline() {
      //this.timeline.timeline.forEach( (entry) => {
        //this.animator.updateTimelineEntry(this.timeline, entry);
      //});
      this.restartGame();
    },
    onChangeComponent({nv,ov}) {
      this.addToUndo('component', {
        nv,
        ov
      });
    },
    onChangeComponentType({nv,ov}) {
      this.addToUndo('component', {
        nv,
        ov
      });
    },

  },
  components:{
    EditorPlayer,
    //QuickTransformEditComponents,
    QuickComponent,
    Timeline,
    ChevronRight,
    ChevronLeft,
    //Close,
    InlineRender,
    QuickChange,
    TimelineClockOutline,
    PlusCircle,
    MinusCircle,
    Undo,
    Redo
  },
  watch: {
    showTimeline(nv) {
      if (!nv) {
        this.$refs.player.clearHighlightTransformSingle();
      }
    }
    /*
    'timeline.timeline': {
      handler(nv) {
        this.updateTimeline();

        //const {duration} = this.animator.getAllTimelines();
        //const gamedata = this.partutil.gamedata.gamedata;
        //this.$set(gamedata.game, 'timelimit', duration);
        //this.timeline.duration = duration;

      },
      deep: true
    }
      */
  },
  computed: {
    windowDuration() {
      return Math.min(8, this.timeline.duration);
    },
    animationClasses() {
      if (this.showTimeline) {
        return 'transparent-button-selected';
      } else {
        return 'transparent-button';
      }
    },
    timelimit() {
      const gamedata = this.partutil.gamedata.gamedata;
      return gamedata.game.timelimit || 0;
    },
  }
}
</script>
<style>
.timeline-transform-button:focus {
  @apply outline-none;
}
.rselected {
  @apply border-2 border-blue-300 mx-1;
  box-sizing: border-box;
}
.notrselected {
  @apply mx-1;
}
.timeline-height {
}
.blank-transform {
  min-height:4rem;
  height:4rem;
  @apply bg-black;
}
</style>
